import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RouteGuardProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<RouteGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

export const AdminRoute: React.FC<RouteGuardProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="text-center p-5">
        <h2>Access Denied</h2>
        <p>You must be an administrator to access this page.</p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  return <>{children}</>;
};

export const UserOrAdminRoute: React.FC<RouteGuardProps> = ({ children }) => {
  const { isAuthenticated, hasRole, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRole('User') && !hasRole('Admin')) {
    return (
      <div className="text-center p-5">
        <h2>Access Denied</h2>
        <p>You must have a valid user role to access this page.</p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  return <>{children}</>;
};
